import ShippingMixin from './ShippingMixin'

export default {
    mixins: [
        ShippingMixin
    ]
}